import { Box, SectionHelper, Text } from '@wix/design-system';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';

const LS_KEY = 'ricos/link-modal/not-published-warning/closed';

export const NotPublishedWarning: React.FC = () => {
  const { t } = useContext(RicosContext);

  const [isClosed, setIsClosed] = useState<boolean>(() => !!localStorage?.getItem(LS_KEY));

  const onClose = () => {
    localStorage?.setItem(LS_KEY, 'true');
    setIsClosed(true);
  };

  if (isClosed) {
    return null;
  }

  return (
    <SectionHelper appearance="standard" onClose={onClose} showCloseButton size="small">
      <Box gap="SP2">
        <Text size="small">{t('LinkSettings_NotPublishedWarning_Text')}</Text>
      </Box>
    </SectionHelper>
  );
};
